import Vue from 'vue';
import { CoordinateService } from '~/utils/coordinate.service';
export default {
    install: function () {
        Vue.prototype.$coordinate = CoordinateService;
    }
};
